import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { getAGraphBaseUrl, getApiBaseUrlSuffix, modifyAGraphURL, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { conditionalParam, isAGraphEnabled } from './AGraphUtils';
import { AW_BRIDGE_API_URL, AW_BRIDGE_API_URL_AGRAPH, PAGINATE_USER_ENTRIES } from './Constants';
import { V1_PROPOSALS_PATH } from './Proposal/v1/Proposal';

export const awBridgeSettings: AGraphApiSettings & {
  getPkgFn?: () => string | undefined;
  getViewAsLoginFn?: () => string | undefined;
  getActAsLoginFn?: () => string | undefined;
} = {};

export const awBridgeApi = axios.create();

awBridgeApi.interceptors.request.use((config) => {
  const { getAladdinApiKey, getPkgFn, getEnvTypeFn, getConfigurationDirectoryFn, getViewAsLoginFn, getActAsLoginFn } =
    awBridgeSettings;

  const pkg = config.params?.pkg ?? getPkgFn?.();
  const configurationDirectory = getConfigurationDirectoryFn ? getConfigurationDirectoryFn() : undefined;
  const envType = getEnvTypeFn?.();
  const viewAs = getViewAsLoginFn?.();
  const actAs = getActAsLoginFn?.();
  const isAGraph = isAGraphEnabled();
  const baseURL = isAGraph
    ? getAGraphBaseUrl(AW_BRIDGE_API_URL_AGRAPH)
    : AW_BRIDGE_API_URL + getApiBaseUrlSuffix(envType, '-', true);

  const autoParams: { [key: string]: string } = { pkg };
  if (configurationDirectory) {
    if (!isAGraph && config.url?.includes(`${V1_PROPOSALS_PATH}/createFrom`)) {
      autoParams.configDir = configurationDirectory;
    } else {
      const configDirectoryParam = conditionalParam(config.url, 'configurationDirectory', configurationDirectory);
      if (configDirectoryParam) {
        autoParams.configurationDirectory = configDirectoryParam;
      }
    }
  }
  const viewAsParam = conditionalParam(config.url, 'viewAs', viewAs);
  if (viewAs && viewAsParam) {
    autoParams.viewAs = viewAsParam;
  }
  // Send userOverride for proposal entries endpoints that need ActAs permissions
  if (actAs && config.url?.includes(PAGINATE_USER_ENTRIES)) {
    autoParams.userOverride = actAs;
  }
  if (config.url?.includes(`${V1_PROPOSALS_PATH}/createFrom`)) {
    config.params.benchmarkType = undefined;
  }

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: config.timeout ?? API_TIMEOUT, // use timeout from config if provided, otherwise default to API_TIMEOUT
    params: {
      ...autoParams,
      ...config.params,
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), envType);
  if (isAGraph) {
    modifyAGraphURL(updatedConfig, ['v1', '/v1', '/v2', 'v3', '/v3', '/v4']);
  }
  return updatedConfig;
});
